import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, FileText, Calendar, Wallet, CheckCircle, Clock, Tag, Home, MapPin } from 'lucide-react';
import { MobileLayout } from '../../components/MobileLayout';
import { useScreenInit } from '../../useScreenInit.js';
import { getApartmentById } from './appartamentiData';
export function CmContrattoDettaglioPage() {
  useScreenInit();
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const apartment = getApartmentById(id);
  if (!apartment || !apartment.contract) {
    return <MobileLayout data-id="element-2236">
        <div className="text-center py-20" data-id="element-2237">
          <p className="text-sm text-muted-foreground mb-4" data-id="element-2238">
            Contratto non trovato.
          </p>
          <Link to={apartment ? `/cm/clienti/appartamenti/${apartment.id}` : '/cm/clienti/appartamenti'} className="inline-flex items-center gap-1.5 text-sm font-medium text-coral hover:underline" data-id="element-2239">
            <ArrowLeft size={15} data-id="element-2240" />
            Torna all'appartamento
          </Link>
        </div>
      </MobileLayout>;
  }
  const contract = apartment.contract;
  const remaining = apartment.cleaningsTotal - apartment.cleaningsDone;
  const pct = apartment.cleaningsTotal > 0 ? Math.round(apartment.cleaningsDone / apartment.cleaningsTotal * 100) : 0;
  const totalEarnings = apartment.interventions.reduce((s, i) => s + i.earning, 0);
  const contractValue = contract.pricePerClean * apartment.cleaningsTotal;
  return <MobileLayout data-id="element-2241">
      {/* Back to apartment */}
      <Link to={`/cm/clienti/appartamenti/${apartment.id}`} className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-navy transition-colors mb-4" data-id="element-2242">
        <ArrowLeft size={16} data-id="element-2243" />
        {apartment.name}
      </Link>

      {/* Header */}
      <div className="mb-6" data-id="element-2244">
        <div className="flex items-center gap-2 flex-wrap" data-id="element-2245">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2246">
            Dettaglio contratto
          </h1>
          <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border ${contract.active ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-gray-100 text-gray-500 border-gray-200'}`} data-id="element-2247">
            <CheckCircle size={12} data-id="element-2248" />
            {contract.active ? 'Attivo' : 'Scaduto'}
          </span>
        </div>
        <div className="flex items-center gap-1.5 text-sm text-muted-foreground mt-1" data-id="element-2249">
          <Home size={14} className="flex-shrink-0" data-id="element-2250" />
          <span data-id="element-2251">{apartment.name}</span>
          <span className="text-border" data-id="element-2252">·</span>
          <MapPin size={13} className="flex-shrink-0" data-id="element-2253" />
          <span className="truncate" data-id="element-2254">{apartment.address}</span>
        </div>
      </div>

      {/* Contract terms */}
      <div className="bg-white border border-border rounded-xl p-4 lg:p-5 mb-6" data-id="element-2255">
        <div className="flex items-center gap-2 mb-4" data-id="element-2256">
          <FileText size={16} className="text-coral" data-id="element-2257" />
          <h2 className="text-sm font-semibold text-navy" data-id="element-2258">
            Condizioni del contratto
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-2259">
          <div className="rounded-lg border border-border p-3" data-id="element-2260">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-2261">
              <Tag size={11} data-id="element-2262" />
              Piano
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-2263">
              {contract.plan}
            </span>
          </div>
          <div className="rounded-lg border border-border p-3" data-id="element-2264">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-2265">
              <Calendar size={11} data-id="element-2266" />
              Scadenza
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-2267">
              {contract.expiry}
            </span>
          </div>
          <div className="rounded-lg border border-border p-3" data-id="element-2268">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-2269">
              <Wallet size={11} data-id="element-2270" />
              Prezzo / pulizia
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-2271">
              €{contract.pricePerClean}
            </span>
          </div>
          <div className="rounded-lg border border-border p-3" data-id="element-2272">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-2273">
              <FileText size={11} data-id="element-2274" />
              Valore contratto
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-2275">
              €{contractValue}
            </span>
          </div>
        </div>
      </div>

      {/* Progress */}
      {apartment.cleaningsTotal > 0 && <div className="bg-white border border-border rounded-xl p-4 lg:p-5 mb-6" data-id="element-2276">
          <div className="flex items-center justify-between mb-2" data-id="element-2277">
            <h2 className="text-sm font-semibold text-navy flex items-center gap-2" data-id="element-2278">
              <Clock size={16} className="text-coral" data-id="element-2279" />
              Avanzamento pulizie
            </h2>
            <span className="text-sm font-semibold text-navy" data-id="element-2280">
              {apartment.cleaningsDone}/{apartment.cleaningsTotal}
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-2" data-id="element-2281">
            <div className="bg-coral h-2 rounded-full transition-all duration-300" style={{
          width: `${pct}%`
        }} data-id="element-2282" />
          </div>
          <p className="text-xs text-muted-foreground" data-id="element-2283">
            {remaining} pulizie ancora disponibili nel pacchetto attivo.
          </p>
        </div>}

      {/* Earnings */}
      <div className="bg-white border border-border rounded-xl p-4 lg:p-5" data-id="element-2284">
        <div className="flex items-center gap-2 mb-4" data-id="element-2285">
          <Wallet size={16} className="text-teal-deep" data-id="element-2286" />
          <h2 className="text-sm font-semibold text-navy" data-id="element-2287">Guadagni maturati</h2>
        </div>
        <div className="grid grid-cols-2 gap-3" data-id="element-2288">
          <div className="rounded-lg bg-navy/5 p-4" data-id="element-2289">
            <div className="text-2xl font-bold text-navy" data-id="element-2290">€{totalEarnings}</div>
            <div className="text-xs text-muted-foreground mt-0.5" data-id="element-2291">
              Totale generato
            </div>
          </div>
          <div className="rounded-lg bg-coral/5 p-4" data-id="element-2292">
            <div className="text-2xl font-bold text-coral" data-id="element-2293">
              €
              {contractValue - totalEarnings > 0 ? contractValue - totalEarnings : 0}
            </div>
            <div className="text-xs text-muted-foreground mt-0.5" data-id="element-2294">
              Potenziale residuo
            </div>
          </div>
        </div>
      </div>
    </MobileLayout>;
}